import type { NxStatusMap } from '@soft2code/nexpo-lib/ui';

/**
 * As situações que o organizador vê: da sessão, do conteúdo e do chamado.
 *
 * `PUBLISHED` diz "No app" e não "Publicado": o que importa a quem monta a
 * feira é se o visitante já enxerga. O chamado segue quem precisa agir.
 */
export const ADMIN_STATUS_MAP: NxStatusMap = {
	DRAFT: { label: { 'pt-BR': 'Rascunho', es: 'Borrador', en: 'Draft' }, tone: 'neutral' },
	PUBLISHED: { label: { 'pt-BR': 'No app', es: 'En la app', en: 'In the app' }, tone: 'success' },
	CANCELLED: { label: { 'pt-BR': 'Cancelada', es: 'Cancelada', en: 'Cancelled' }, tone: 'danger' },
	LIVE: { label: { 'pt-BR': 'Ao vivo', es: 'En vivo', en: 'Live' }, tone: 'live' },
	FINISHED: { label: { 'pt-BR': 'Encerrada', es: 'Finalizada', en: 'Finished' }, tone: 'neutral' },
	ARCHIVED: { label: { 'pt-BR': 'Fora do ar', es: 'Fuera de línea', en: 'Off the app' }, tone: 'neutral' },

	OPEN: { label: { 'pt-BR': 'Novo', es: 'Nuevo', en: 'New' }, tone: 'info' },
	PROGRESS: { label: { 'pt-BR': 'Em andamento', es: 'En curso', en: 'In progress' }, tone: 'warning' },
	RESOLVED: { label: { 'pt-BR': 'Resolvido', es: 'Resuelto', en: 'Resolved' }, tone: 'success' },
	CLOSED: { label: { 'pt-BR': 'Fechado', es: 'Cerrado', en: 'Closed' }, tone: 'neutral' },
};
